import { Utils } from '../../app.base'
import { MsgBox, Vue } from '../../app.vues';

import SwbDevcSplitFormSave from './DevcSplitFormSave';
Vue.regist(SwbDevcSplitFormSave);
//
import SwbDevcSplitFormDetail from './DevcSplitFormDetail';
Vue.regist(SwbDevcSplitFormDetail);
//
import SwbDevcSplitAuditRecList from './DevcSplitAuditRecList';
Vue.regist(SwbDevcSplitAuditRecList);

// 拆分单保存
export function openDevcSplitFormSavelDlg(params, callback) {
    let id = params['id'] || null;
    let title = params['title'] || '拆分单 - 保存';
    let comId = params['comId'] || null;
    let comFullName = params['comFullName'] || null;
    let showApplyBtn = Utils.isTrue(params['showApplyBtn']); // 是否展示申请按钮
    //
    let theDlg = Vue.$showDialog({
        title: title,
        width: -100,
        height: 850,
        showCloseBtn: false,
        okText: '保存',
        cancelText: '关闭',
        extVisible: showApplyBtn,
        extText: '申请',
        template: '<div class = "">' +
        '<swb-devc-split-form-save :id="id" :comId="comId" :comFullName="comFullName" ref="swb_devc_split_form_save"></swb-devc-split-form-save>' +
        '</div>',
        data: {
            id: id,
            comId: comId,
            comFullName: comFullName
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_devc_split_form_save.getDlgResult();
            if(result != null) {
                if(result.type == 'info') {
                    //
                    callback(result.data, theDlg, false);
                } else {
                    MsgBox.warning(result.message);
                    return false;
                }
            }
            return false;
        },
        cancelClicked: function () {
            let self = this;
            let result = self.$refs.swb_devc_split_form_save.getFormInfo();
            let dbFormInfo = result.dbFormInfo || {};
            let formInfo = result.formInfo || {};
            if(!Utils.isNoB(dbFormInfo.id) && !Utils.obj_val_equal(formInfo, dbFormInfo, false, [])) {
                this.$confirm('存在未保存内容，是否确定关闭当前页面?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    theDlg.close();
                }).catch(function () {
                    return false;
                });
            } else {
                return true;
            }
            return false;
        },
        // onClosed: function () {
        //     let self = this;
        //     let result = self.$refs.swb_devc_split_form_save.getFormInfo();
        //     let dbFormInfo = result.dbFormInfo || {};
        //     let formInfo = result.formInfo || {};
        //     if(!Utils.isNoB(dbFormInfo.id) && !Utils.obj_val_equal(formInfo, dbFormInfo, false, [])) {
        //         this.$confirm('存在未保存内容，是否确定关闭当前页面?', '提示', {
        //             confirmButtonText: '确定',
        //             cancelButtonText: '取消',
        //             type: 'warning'
        //         }).then(function () {
        //             theDlg.close();
        //         }).catch(function () {
        //             return false;
        //         });
        //     } else {
        //         return true;
        //     }
        //     return false;
        // },
        extClicked: function () {
            let self = this;
            let result = self.$refs.swb_devc_split_form_save.getDlgResult();
            if (result != null) {
                if (result.type == 'info') {
                    //
                    callback(result.data, theDlg, true);
                } else {
                    MsgBox.warning(result.message);
                }
            }
            return false;
        },
        lifecycle: {
            created: function () {
            }
        }
    });
}

// 拆分单详情
export function openDevcSplitFormDetailDlg(title, params) {
    title = Utils.isNoB(title) ? "拆分单 - 详情" : title;
    let id = params["id"] || null;
    //
    let theDlg = Vue.$showDialog({
        title: title,
        width: -200,
        height: -100,
        showCloseBtn: true,
        okVisible: false,
        cancelText: "关闭",
        template: '<swb-devc-split-form-detail :id="id" ref="swb_devc_split_form_detail"></swb-devc-split-form-detail>',
        data: {
            id: id
        },
        okClicked: function () {
        },
        lifecycle: {
            created: function () {
            }
        }
    });
}

// 拆分单详情
export function openDevcSplitAuditRecListDlg(id) {
    //
    let theDlg = Vue.$showDialog({
        title: '拆分单 - 审核记录',
        width: -200,
        height: -100,
        showCloseBtn: true,
        okVisible: false,
        cancelText: "关闭",
        template: '<swb-devc-split-audit-rec-list :id="id" ref="swb_devc_split_audit_rec_list"></swb-devc-split-audit-rec-list>',
        data: {
            id: id
        },
        okClicked: function () {
        },
        lifecycle: {
            created: function () {
            }
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/devcSplit/showDlg.js
// module id = 2633
// module chunks = 0